function normalizedOptionKey(option: string): string {
  return option.trim().replace(/\s+/g, " ").toLocaleLowerCase();
}

/** Indices whose non-empty labels occur more than once after basic normalization. */
export function getDuplicateOptionIndices(options: readonly string[]): Set<number> {
  const indicesByLabel = new Map<string, number[]>();

  options.forEach((option, index) => {
    const key = normalizedOptionKey(option);
    if (!key) return;
    const indices = indicesByLabel.get(key) ?? [];
    indices.push(index);
    indicesByLabel.set(key, indices);
  });

  const duplicates = new Set<number>();
  for (const indices of indicesByLabel.values()) {
    if (indices.length < 2) continue;
    indices.forEach((index) => duplicates.add(index));
  }
  return duplicates;
}
